window.ClientPortalAPI = new (function () {
  var self = this;
  var _protected = BaseAPI.call(self);

  // Default caching for this API
  _protected.CACHING_TIMEOUT = 3 * 1000; // ms

  /**
   *
   * Get list of client portal candidates
   * API:  /api/v1/client_portal_list
   * Type: POST
   *
   **/
  self.getCandidates = function (params) {

    var deferred = $q.defer();

    var requestPayload = {};

    requestPayload = {
      brand_id: params.clientId ,
      limit: params.limit,
      offset: params.offset
    };

    if(params.lastTime){
      requestPayload.lastTime = params.lastTime;
    }
    if(params.selectedFilter){
      requestPayload.client_response = params.selectedFilter;
    }
    _protected.request('client_portal_list', 'POST', requestPayload).then(function (result) {

      if(result && result.data && result.data.data && result.data.status_code == 200){
        deferred.resolve(result.data.data);
      }else{
        deferred.reject(data);
      }

    }, function (err) {
      deferred.reject(err);
    });

    return deferred.promise;
  };

  /**
   *
   * Get list of client portal candidates ids
   * API:  /api/v1/client_portal_list
   * Type: POST
   *
   **/
  self.getCandidatesIds = function (params) {

    var deferred = $q.defer();

    var requestPayload = {};

    requestPayload = {
      brand_id: params.clientId ,
      limit: params.limit,
      offset: params.offset,
      only_ids: 1
    };

    if(params.lastTime){
      requestPayload.lastTime = params.lastTime;
    }

    if(params.selectedFilter){
      requestPayload.client_response = params.selectedFilter;
    }
    
    _protected.request('client_portal_list', 'POST', requestPayload).then(function (result) {

      if(result && result.data && result.data.data && result.data.status_code == 200){
        deferred.resolve(result.data.data);
      }else{
        deferred.reject(result);
      }

    }, function (err) {
      deferred.reject(err);
    });

    return deferred.promise;
  };

  /**
   *
   * remove Candidate
   * API:  /api/v1/client_portal
   * Type: POST
   * Payload: array of ids and client id
   **/
  self.removeCandidates = function(arr,client_id){

    var deferred = $q.defer();


    var requestPayload = {};
    requestPayload.client_portal_ids = arr;
    requestPayload.brand_id = client_id;

    _protected.request('client_portal', 'POST', requestPayload).then(function (result) {
      if(result && result.data && result.data.status_code == 200){
        deferred.resolve(result.data);
      }else{
        deferred.reject(err);
      }

    }, function (err) {
      deferred.reject(err);
    });

    return deferred.promise;
  }

  /**
   *
   * like & un-like Candidate
   * API: /api/v1/client_portal_candidate_like
   * Type: POST
   * Payload: client_portal_id, like_flag
   **/
  self.updateCandidateLikeStatus = function(candidateId,likeStatus){

    var deferred = $q.defer();


    var requestPayload = {};
    requestPayload.client_portal_id = candidateId;
    requestPayload.like_flag = likeStatus;

    _protected.request('client_portal_candidate_like', 'POST', requestPayload).then(function (result) {
      deferred.resolve(result);
    }, function (err) {
      deferred.reject(err);
    });

    return deferred.promise;
  }


  /**
   *
   * Get list of client portal client_admins
   * API: /api/v1/client_admin
   * Type: GET
   **/

  self.getClientPortalAdmins = function(brandId){

    var deferred = $q.defer();

    var limit = 100, offset = 0;

    _protected.request('client_admin?brand_id='+brandId+'&limit='+limit+'&offset='+offset, 'GET').then(function (result) {
      if(result && result.data && result.data.data && result.data.data.length > 0){
        deferred.resolve(result.data.data);
      }else{
        deferred.reject(result);
      }

    }, function (err) {
      deferred.reject(err);
    });

    return deferred.promise;
  }

  var isBeingLoaded = false;
  var promises = [];

  /**
   *
   * Get list of client portal shared with this client admin
   * API: /api/v1/client_admin_portals
   * Type: GET
   **/

  self.getPortalsSharedWithAdmin = function(){

    var deferred = $q.defer();

    if (_protected.getCached(0)) {
      deferred.resolve(_protected.getCached(0));
      return deferred.promise;
    }

    promises.push(deferred);

    if (isBeingLoaded) {
      return deferred.promise;
    }

    isBeingLoaded = true;

    _protected.request('client_admin_portals', 'GET').then(function (result) {
      isBeingLoaded = false;
      if(result && result.data && result.data.data && result.data.status_code == 200){
        _protected.cache(0, result.data.data);

        promises.forEach(function(deferred) {
          deferred.resolve(result.data.data);
        });
      }else{
        deferred.reject(result);
      }

    }, function (err) {
      isBeingLoaded = false;
      promises.forEach(function(deferred) {
        deferred.reject(err);
      });
    });

    return deferred.promise;
  }

});
